import * as PDFJS from 'pdfjs-dist'
import urlUitls from '../../../static/js/urlUitls'

PDFJS.GlobalWorkerOptions.workerSrc = urlUitls.getSrc('/static/pdf/2.6.347/build/pdf.worker.min.js')

export default {
  data() {
    return {
      pdf: {
        totalPages: 0, // pdf 总页数
        curPage: 1, // pdf 当前页码
        pdfDoc: null, // pdf 实例
      },
    }
  },
  methods: {
    // 获取 pdf 数据
    loadFile(url) {
      //此处如果是http地址则转换为当前域名下的地址，由后台去做反代
      url = url?.replace?.(/^https?:\/\/.*.com\//, '/resources/')
      this.$axios
        .get(urlUitls.getDomain(url), { responseType: 'blob' })
        .then((res) => {
          // 此处是将 blob 转换成 ArrayBuffer
          const reader = new FileReader()
          reader.onload = (_res) => {
            if (_res.target.result) {
              this.readPdf(_res.target.result)
            } else {
              console.log('加载 PDF 数据失败！')
            }
          }
          reader.readAsArrayBuffer(res.data)
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    // 读取 pdf 数据
    readPdf(data) {
      const pdfInstance = PDFJS.getDocument({
        data: data,
        cMapUrl: urlUitls.getSrc('/static/pdf/2.6.347/cmaps/'),
        cMapPacked: true,
      })
      // data 是一个 ArrayBuffer 格式，也是一个 buffer 流的数据
      pdfInstance.promise
        .then((pdfDoc) => {
          this.pdf.pdfDoc = pdfDoc
          this.pdf.totalPages = pdfDoc.numPages // pdf的总页数

          this.renderPage(this.pdf.curPage)
        })
        .catch((error) => console.log('error: ', error))
    },
    renderPage(num) {
      if (!this.pdf?.pdfDoc) throw new Error('pdfDoc 不可为空！')
      if (!num) throw new Error('num 不可为 0 或空！')

      this.$nextTick(() => {
        this.pdf.pdfDoc.getPage(num).then((page) => {
          // 设置 canvas 相关的属性
          const canvas = this.$refs.pdfCanvas
          const ctx = canvas.getContext('2d')
          const dpr = window.devicePixelRatio || 1 // 设备像素比
          const bsr =
            ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio ||
            1 // 浏览器在渲染 canvas 之前会用几个像素来来存储画布信息,类似img
          const ratio = dpr / bsr
          const scale = +`${this.pdfScale}` || 1.5
          const viewport = page.getViewport({ scale })
          canvas.width = viewport.width * ratio // 画布大小,默认值是 width:300px, height:150px
          canvas.height = viewport.height * ratio

          this.modalWidth = canvas.width + 40

          // console.log(viewport, canvas, ratio, scale, this.pdfScale)

          const renderContext = {
            canvasContext: ctx,
            viewport,
          }

          // 渲染
          page.render(renderContext)
        })
      })
    },
  },
}
